module.exports = __webpack_public_path__ + "media/images/neutral-3a1aa983230c4ceb56f3d7b191e706d9.svg";